import { LoginForm } from "@/components/login-form";
import PageLoader from "@/components/ui/PageLoader";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { Navigate } from "react-router-dom";

export default function LoginPage() {
  const { authStatus } = useAuthenticator((context) => [context.user]);

  if (authStatus === "authenticated") return <Navigate to="/" />;

  return (
    <div className="flex min-h-svh flex-col items-center justify-center p-6 md:p-10">
      <div className="w-full max-w-sm md:max-w-3xl">
        {authStatus === "configuring" ? <PageLoader /> : <LoginForm />}
      </div>
    </div>
  );
}
